import React from 'react';

import { ModalProvider, useModalContext } from '@magoosh/context/modal_context';
import { ButtonProps, SecondaryButton } from '@magoosh/lib/button';
import { AudioSetupModal, hasCompletedAudioSetup } from '@magoosh/organisms/audio/setup';

interface Props {
  Button?: React.ComponentType<any>;
  activityName?: string;
  block?: boolean;
  children: string | React.Component;
  className?: string;
  disabled?: boolean;
  includesSpeaking?: boolean;
  onStart: () => void;
  size?: ButtonProps['size'];
}

const StartButton = (props: Props) => {
  const { setModal } = useModalContext();

  const Button = props.Button || SecondaryButton;

  const onClick = () => {
    if (props.includesSpeaking && !hasCompletedAudioSetup()) {
      setModal({
        body: (
          <AudioSetupModal
            onClose={() => setModal(null)}
            onFinished={props.onStart}
          />
        ),
        header: 'Audio/Microphone Setup',
        subHeader: `Let's verify that your audio output and microphone are working properly, then we'll start your ${props.activityName || 'Practice Session'}.`
      });
    } else {
      props.onStart();
    }
  };

  return (
    <Button
      block={props.block}
      className={props.className}
      disabled={props.disabled}
      onClick={onClick}
      size={props.size}
    >
      {props.children}
    </Button>
  );
};

export default (props: Props) => {
  return (
    <ModalProvider>
      <StartButton {...props} />
    </ModalProvider>
  );
};
